import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const planEntries = createSelector(
  state => state.orm,
  ormCreateSelector(orm, session => {
    return session.PlanEntry.all().toModelArray()
  })
)

export const getPlanEntryGridState = createSelector(
  state => state.ui.planEntries,
  planEntryState => {
    return planEntryState.grid
  }
)

export const isPlanEntryFeatured = (state, entryId) => {
  const selector = createSelector(
    state => state.orm,
    state => state.orm.PlanEntry.itemsById[`${entryId}`].featured,
    ormCreateSelector(orm, (_, featured) => {
      return featured
    })
  )
  return selector(state)
}
